// routesMap.js
import {Pricing} from "../components/Pages/Pricing/Pricing";
import {Result} from "../components/Pages/Pricing/Result";
import RealtimeMonitoring from "../components/Pages/RealtimeMonitoring";
import AiBased from "../components/Pages/AiBased";
import AnalyzeResults from "../components/Pages/Home/AnalyzeResults";
import FiveTipsForEmailSecurity from "../components/Posts/FiveTipsForEmailSecurity";
import DmarcMadeEasy from "../components/Posts/DmarcMadeEasy";
import BimiImportance from "../components/Posts/BimiImportance";
import {DMARCChecker} from "../components/Pages/DMARC/Checker/DMARCChecker";
import {DMARCGenerator} from "../components/Pages/DMARC/Generator/DMARCGenerator";
import {EnterpriseDMARC} from "../components/Pages/DMARC/EnterpriseDMARC";
import {DMARCResult} from "../components/Pages/DMARC/Checker/DMARCResult";
import {SPFRecordChecker} from "../components/Pages/SPF/SPFRecordChecker";
import {SPFGenerator} from "../components/Pages/SPF/SPFGenerator";
import {SPFProtection} from "../components/Pages/SPF/SPFProtection";
import {SpfResult} from "../components/Pages/SPF/SpfResult";
import {DKIMChecker} from "../components/Pages/DKIM/DKIMChecker";
import {DKIMGenerator} from "../components/Pages/DKIM/DKIMGenerator";
import {DKIMResult} from "../components/Pages/DKIM/DKIMResult";
import {BimiChecker} from "../components/Pages/BIMI/BimiChecker";
import {BIMIGenerator} from "../components/Pages/BIMI/BIMIGenerator";
import {EnterpriseBIMI} from "../components/Pages/BIMI/EnterpriseBIMI";
import BIMIResult from "../components/Pages/BimiResult";
import HomePage from "../components/Pages/Home/HomePage";
import {Privacy} from "../components/Pages/Privacy/Privacy";
import {DMARCflowPartnerPage} from "../components/Pages/DMARCflowPartnerPage";

export const routes = {
    pricing: {
        en: 'pricing',
        de: 'preise',
        element: Pricing
    },
    paymentResult: {
        en: 'subscribed',
        de: 'subscribed',
        element: Result
    },
    realtimeMonitoring: {
        en: "realtime-monitoring",
        de: "echtzeit-ueberwachung",
        element: RealtimeMonitoring
    },
    aiBasedDmarcReporting: {
        en: "ai-based-dmarc-reporting",
        de: "ki-basiertes-dmarc-reporting",
        element: AiBased
    },
    analyzeResults: {
        en: "analyze-results",
        de: "analyse-ergebnisse",
        element: AnalyzeResults
    },
    fiveTipsForEmailSecurity: {
        en: 'five-tips-for-email-security',
        de: "fuenf-tipps-fuer-email-sicherheit",
        element: FiveTipsForEmailSecurity
    },
    dmarcMadeEasy: {
        en: "dmarc-made-easy",
        de: "dmarc-ganz-einfach",
        element: DmarcMadeEasy
    },
    whyBimiIsImportantForYourBrand: {
        en: "why-bimi-is-important-for-your-brand",
        de: "warum-bimi-fuer-ihre-marke-unerlasslich-ist",
        element: BimiImportance
    },
    dmarcRecordChecker: {
        en: "dmarc/record-checker",
        de: "dmarc/datensatz-pruefer",
        element: DMARCChecker
    },
    home: {
        en: "",
        de: "",
        element: HomePage
    },
    dmarcRecordGenerator: {
        en: "dmarc/record-generator",
        de: "dmarc/datensatz-generator",
        element: DMARCGenerator
    },
    enterpriseEmailProtectionWithDmarc: {
        en: "dmarc/enterprise-email-protection-with-dmarc",
        de: "dmarc/enterprise-email-schutz-mit-dmarc",
        element: EnterpriseDMARC
    },
    dmarcResult: {
        en: "dmarc/result",
        de: "dmarc/ergebnis",
        element: DMARCResult
    },
    spfRecordChecker: {
        en: "spf/record-checker",
        de: "spf/datensatz-pruefer",
        element: SPFRecordChecker
    },
    spfRecordGenerator: {
        en: "spf/record-generator",
        de: "spf/datensatz-generator",
        element: SPFGenerator
    },
    spfProtectionWithSpf: {
        en: "spf/protection-with-spf",
        de: "spf/schutz-durch-spf",
        element: SPFProtection
    },
    spfResult: {
        en: "spf/result",
        de: "spf/ergebnis",
        element: SpfResult
    },
    dkimRecordChecker: {
        en: "dkim/record-checker",
        de: "dkim/datensatz-pruefer",
        element: DKIMChecker
    },
    dkimRecordGenerator: {
        en: "dkim/record-generator",
        de: "dkim/datensatz-generator",
        element: DKIMGenerator
    },
    dkimResult: {
        en: "dkim/result",
        de: "dkim/ergebnis",
        element: DKIMResult
    },
    bimiRecordChecker: {
        en: "bimi/record-checker",
        de: "bimi/datensatz-pruefer",
        element: BimiChecker
    },
    bimiRecordGenerator: {
        en: "bimi/record-generator",
        de: "bimi/datensatz-pruefer",
        element: BIMIGenerator
    },
    bimiEnterpriseBimiSolutions: {
        en: "bimi/enterprise-bimi-solutions",
        de: "bimi/enterprise-bimi-loesungen",
        element: EnterpriseBIMI
    },
    bimiResult: {
        en: "bimi/result",
        de: "bimi/ergebnis",
        element: BIMIResult
    },
    privacyPolicy: {
        en: "privacy-policy",
        de: "datenschutzerklaerung",
        element: Privacy
    },
    domainCheckerPartnerPage: {
        en: "partner/record-checker",
        de: "partner/record-checker",
        element: DMARCflowPartnerPage
    },
};
